const codeModule = {
  "101": "데이터를 받지 못했습니다",
  "102": "서명 검증 실패, 다시 로그인 하십시오",
  "103": "인증번호 전송 실패",
  "104": "핸드폰 번호 부족",
  "105": "비밀번호 부족",
  "106": "본 번호는 이미 등록되었으니, 로그인으로 돌아가십시오",
  "111": "로그인 실패",
  "107": "인증 번호 틀림",
  "108": "계정 암호 불일치",
  "109": "계정 불존재",
  "110": "비밀번호 수정 실패",
  "112": "탈퇴 실패",
  "113": "사용자 정보 수정 실패",
  "114": "파라미터 부족",
  "115": "저장 실패",
  "121": "카드 정보가 완전하지 않습니다",
  "122": "없다ID",
  "201": "가게 불존재",
  "202": "테이블 불존재",
  "203": "연속 댓 글 불가",
  "204": "사용자는 어떤 가게에서도 소비한 적이 없습니다",
  "205": "푸드코트 불존재",
  "206": "가게 미개점",
  "301": "상품 유형 미첨가",
  "302": "상품 불존재",
  "303": "품절",
  "304": "세트 적용 인원수를 입력하십시오",
  "305": "메뉴 불존재",
  "306": "세트 불존재",
  "307": "가게 안 불가",
  "308": "배송 자동제출 불가",
  "309": "일부 상품은 재고가 부족하다",
  "400": "보안 코드 불정확",
  "401": "배송 주소 불존재",
  "403": "배송범위초과",
  "404": "장바구니에 상품이 없습니다",
  "405": "식객 수를 입력하십시오",
  "407": "테이블을 선택하십시오",
  "408": "본 테이블은 이미 고정되었습니다",
  "409": "배송 가격 미달성",
  "410": "총 금액은 반드시 1엔보다 커야 합니다",
  "411": "추가 주문에 실패, 다시 시도하십시오",
  "412": "주문서 불존재",
  "413": "본 주문서는 지불했습니다",
  "415": "주문서 평가했습니다",
  "416": "등급을 선택하십시오",
  "417": "실패에 대한 평가를 다시 시도하십시오",
  "418": "수령서 출력",
  "419": "출력 실패",
  "420": "회사 이름을 입력하십시오",
  "421": "주문서 미평가",
  "422": "지급 주문 취소",
  "423": "취소 실패",
  "424": "이 주문에 대해 조작할 권한이 없습니다",
  "425": "확인수취실패",
  "426": "본 주문은 추가할 수 없습니다",
  "427": "신용카드 정보 오류, 검사하십시오",
  "428": "지급 실패, 검사후 다시 시도하십시오",
  "429": "직접 찾기 시간 내 아닙니다",
  "430": "배송 시간 내 아닙니다",
  "431": "지원되지 않는 지불 방식",
  "433": "시간을 선택하지 않다",
  "501": "쿠폰이 없습니다.",
  "502": "이미다 받았다",
  "503": "1인 수령 상한선을 초과하다",
  "504": "수신에 실패했습니다. 다시 시도하십시오",
  "505": "쿠폰이 이미 사용되었거나 기간이 지났습니다",
  "506": "사용 조건을 만족시키지 못하다",
  "1000": "다품격 상품은 장바구니에서 삭제하시기 바랍니다!",
  "1001": "수취 성공 확인"
};

export default codeModule;
